<template>
  <div id="navigation-mobile">
    <ul class="menu-items">
      <li class="p-fs-l">
        <router-link data-item="صفحه اصلی" :to="{ name: 'Home' }">
          صفحه اصلی
        </router-link>
      </li>
      <li class="p-fs-l">
        <router-link data-item="سرویس‌های خبری" :to="{ name: 'NewsList' }">
          سرویس‌های خبری
        </router-link>
      </li>
      <li class="p-fs-l">
        <h5 class="p-fs-l">
          <button v-b-toggle.collapse-3 class="text-p-first p-fw-bold pe-0">
            چندرسانه‌ای
          </button>
        </h5>
        <b-collapse id="collapse-3">
          <div class="d-flex align-items-center mt-3 me-2">
            <b-icon
              icon="circle-fill"
              scale="0.4"
              class="text-p-readonly"
            ></b-icon>
            <router-link :to="{ name: 'MultiMedia' }">
              <h5 class="text-p-primary">لیست چند رسانه ای</h5>
            </router-link>
          </div>
          <div class="d-flex align-items-center mt-3 me-2">
            <b-icon
              icon="circle-fill"
              scale="0.4"
              class="text-p-readonly"
            ></b-icon>
            <router-link :to="{ name: 'Podcast' }">
              <h5 class="text-p-primary">صوت‌ها</h5>
            </router-link>
          </div>
          <div class="d-flex align-items-center mt-3 me-2">
            <b-icon
              icon="circle-fill"
              scale="0.4"
              class="text-p-readonly"
            ></b-icon>
            <router-link :to="{ name: 'Video' }">
              <h5 class="text-p-primary">ویدیوها</h5>
            </router-link>
          </div>
          <div class="d-flex align-items-center mt-3 me-2">
            <b-icon
              icon="circle-fill"
              scale="0.4"
              class="text-p-readonly"
            ></b-icon>
            <router-link :to="{ name: 'ImageDetails' }">
              <h5 class="text-p-primary">تصاویر</h5>
            </router-link>
          </div>
        </b-collapse>
      </li>
      <li>
        <h5 class="p-fs-l">
          <button v-b-toggle.collapse-1 class="text-p-first p-fw-bold pe-0">
            معرفی سازمان
          </button>
        </h5>
        <b-collapse id="collapse-1" v-for="item in items" :key="item.id">
          <div class="d-flex align-items-center mt-3 me-2">
            <b-icon
              icon="circle-fill"
              scale="0.4"
              class="text-p-readonly"
            ></b-icon>
            <router-link
              :to="{
                name: 'AboutOrganization',
                params: { id: item.id },
              }"
            >
              <h5 class="text-p-primary">
                {{ item.title }}
              </h5>
            </router-link>
          </div>
        </b-collapse>
      </li>
      <li class="p-fs-l">
        <router-link data-item="تماس با ما" :to="{ name: 'CountactUs' }">
          تماس با ما
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TheNavbar",
  data() {
    return {
      showMobileMenu: false,
    };
  },
  computed: {
    ...mapGetters({
      items: "newsX/introductions",
    }),
  },
  method: {
    showMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
  },
  beforeCreate() {
    this.$store.dispatch("newsX/getIntroductions");
  },
};
</script>
<style lang="sass"></style>
